var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreMatching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CFEBCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#CFEBCE",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6302_2320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 30.6667C47 29.429 46.5083 28.242 45.6332 27.3668C44.758 26.4917 43.571 26 42.3333 26H30.6667C29.429 26 28.242 26.4917 27.3668 27.3668C26.4917 28.242 26 29.429 26 30.6667V42.3333C26 43.571 26.4917 44.758 27.3668 45.6332C28.242 46.5083 29.429 47 30.6667 47V37.6667C30.6667 35.8102 31.4042 34.0297 32.7169 32.7169C34.0297 31.4042 35.8102 30.6667 37.6667 30.6667H47Z",
    fill: "#00848D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3333 33C50.571 33 51.758 33.4917 52.6332 34.3668C53.5083 35.242 54 36.429 54 37.6667V49.3333C54 50.571 53.5083 51.758 52.6332 52.6332C51.758 53.5083 50.571 54 49.3333 54H37.6667C36.429 54 35.242 53.5083 34.3668 52.6332C33.4917 51.758 33 50.571 33 49.3333V37.6667C33 36.429 33.4917 35.242 34.3668 34.3668C35.242 33.4917 36.429 33 37.6667 33H49.3333Z",
    fill: "#00848D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6302_2320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(26 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreMatching);
export default __webpack_public_path__ + "static/media/exploreMatching.705369d2294c82a85860a40c29dea738.svg";
export { ForwardRef as ReactComponent };